<template>
  <div class="text-center">
    <v-menu
      v-model="menu"
      :close-on-click="false"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          text
          small
          v-bind="attrs"
          v-on="on"
          :disabled="disabled"
        >
          <span v-if="Boolean(number)">{{ number }}</span>
          <v-icon v-else small>mdi-plus</v-icon>
        </v-btn>
      </template>

      <v-card>
        <validation-observer v-slot="{ invalid }" ref="form">
          <v-card-text>
            <validation-provider
              :rules="{ required: true }"
              v-slot="{ errors }"
            >
              <v-text-field
                v-model="updatedNumber"
                :label="display.number"
                autofocus
                prepend-icon="mdi-check-box-outline"
                class="mb-5"
                :error-messages="errors"
              >
              </v-text-field>
            </validation-provider>
            <date-picker
              :value="updatedDate"
              :field="{ label: display.date }"
              :validations="{ required: true }"
              @fieldChange="updatedDate = $event"
            ></date-picker>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" text @click="clear"> Cancel </v-btn>
            <v-btn
              color="primary"
              text
              :dark="!invalid"
              :disabled="invalid"
              @click="save"
            >
              Save
            </v-btn>
          </v-card-actions>
        </validation-observer>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
export default {
  props: ["number", "date", "display", "disabled"],
  data() {
    return {
      menu: false,
      updatedNumber: this.number || "",
      updatedDate: this.date
        ? new Date(this.date)
        : new Date(new Date().toDateString()),
    };
  },
  methods: {
    async save() {
      this.menu = false;
      this.$emit("save", this.updatedNumber, this.updatedDate);
    },
    clear() {
      this.updatedNumber = this.number || "";
      this.updatedDate = this.date
        ? new Date(this.date)
        : new Date(new Date().toDateString());
      this.$refs.form.reset();
      this.menu = false;
    },
  },
};
</script>
